// Try to get the data from the cache
let cachedIngredientsData = localStorage.getItem("ingredientsData");
let ingredientsData;

if (cachedIngredientsData) {
  ingredientsData = JSON.parse(cachedIngredientsData);
}

window.addEventListener("DOMContentLoaded", async function () {
  const $ingredientsBlock = document.getElementById("how-to-formula-container");

  if ($ingredientsBlock) {
    // If data wasn't cached, fetch it
    if (!ingredientsData) {
      const responseFromFirebase = await fetch(
        "https://us-central1-dime-app-8394d.cloudfunctions.net/api/ingredients"
      );
      ingredientsData = await responseFromFirebase.json();

      localStorage.setItem("ingredientsData", JSON.stringify(ingredientsData));
    }

    document.querySelectorAll("[data-ingredient-id]").forEach(($row) => {
      const ingredientData = ingredientsData[$row.dataset.ingredientId];
      if (ingredientData) {
        const ingredientContent = `<span>${ingredientData.name}</span>${ingredientData.description}`;
        $row.innerHTML = ingredientContent;
      }
    });
  }
});
